import {Map, Overlay, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import TileWMS from 'ol/source/TileWMS';
import $ from 'jquery';

function initMap() {
    window.reception_map = new Map({
        target: 'map',
        layers: [
            new TileLayer({
                source: new OSM()
            }),
        ],

        view: new View(
            {
                center: [1741463, 59],
                zoom: 10,
                extent: [1508793.8766715527, 5882173.3797687525, 1787506.489521506, 6074727.136021124],
            }
        )
    });
}

function toggleMapLayer() {
    let value = $(this).is(':checked');
    let id = $(this).attr('id');
    let [_, workspace, layer] = id.match(/^cb;(.+);(.+)$/);
    if (value) {
        window.reception_map.addLayer(window.map_layers[workspace][layer]);
    } else {
        window.reception_map.removeLayer(window.map_layers[workspace][layer]);
    }
}

function toggleAll() {
    let value = $(this).val();
    if (value === "all") {
        $("input.layer-checkbox:checked").prop('checked', false);
        $("input.layer-checkbox").trigger('change');
        $(this).val('none').text('Keine');
        let workspace = $("select#ws_select").val()
        window.map_all_layers[workspace].map((layer, idx) => {
            window.reception_map.addLayer(layer);
        });
    } else {
        $("input.layer-checkbox:checked").prop('checked', false);
        $("input.layer-checkbox").trigger('change');
        $(this).val('all').text('Alle');
        let workspace = $("select#ws_select").val()
        window.map_all_layers[workspace].map((layer, idx) => {
            window.reception_map.removeLayer(layer);
        });
    }
}

function selectWorkspace() {
    let value = $(this).val()
    if (value === "") return;
    $("#ws_checkboxes > div").hide();
    $("#ws_select_all").show();
    $(`#cbcont-${value}`).show();
    $("input.layer-checkbox:checked").prop('checked', false);
    $("button#ws_select_all").val('all').text('Alle');
    window.reception_map = null;
    $("#map").empty();
    $("div#legend-container").empty()
    initMap();
    fetch(`/api/s/legend-${value}.s`).then(response => {
        if (response.status === 200) {
            return response.text();
        } else {
            throw new Error("Legend API returned error " + response.status);
        }
    }).then(
        contents => {
            $("div#legend-container").html(contents);
        });
}

window.onload = function (_) {
    $("button#ws_select_all").click(toggleAll);
        const urlParams = new URLSearchParams(window.location.search);
        const session_id = urlParams.get('session');
        document.cookie = "JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = `JSESSIONID=${session_id}`;

        fetch('/geoserver/rest/layers').then(response => {
            if (response.status === 200) {
                return response.json();
            } else {
                throw new Error("Layer discovery returned error " + response.status);
            }
        }).then(layers => {
            let ll = layers["layers"]["layer"];
            let l_map = ll.reduce((acc, layer, _, __, ___) => {
                let [ws, name] = layer["name"].split(":", 2);
                if (acc.hasOwnProperty(ws)) {
                    acc[ws].push(name);
                } else {
                    acc[ws] = [name];
                }
                return acc;
            }, {});
            return l_map;
        }).then(
            data => {
                window.map_layers = {};
                window.map_all_layers = {}
                let selects = [];
                let ws_checkboxes = [];
                for (let [workspace, received_layers] of Object.entries(data)) {
                    let all_layers = [];
                    for (let layer_name of [`${workspace}_all`]) {
                        let layer = new TileLayer({
                            source: new TileWMS({
                                url: `/geoserver/${workspace}/wms`,
                                params: {
                                    "STYLES": '',
                                    "LAYERS": layer_name,
                                    "exceptions": 'application/vnd.ogc.se_inimage',
                                }
                            })
                        });
                        layer.setOpacity(.3)
                        all_layers.push(layer);
                    }
                    window.map_all_layers[workspace] = all_layers;
                    let checkbox_container = $(`<div class="cbcont" id="cbcont-${workspace}"></div>`).hide();
                    if (!(workspace in window.map_layers)) window.map_layers[workspace] = {};
                    let ws_option = $(`<option value="${workspace}">${workspace}</option>`);
                    $("select#ws-select").append(ws_option);
                    selects.push(ws_option);
                    received_layers.map((layer_name, index) => {
                        let layer = new TileLayer({
                            source: new TileWMS({
                                url: `/geoserver/${workspace}/wms`,
                                params: {
                                    "STYLES": '',
                                    "LAYERS": layer_name,
                                    "exceptions": 'application/vnd.ogc.se_inimage',
                                }
                            })
                        });
                        layer.setOpacity(.3)
                        window.map_layers[workspace][layer_name] = layer;
                        let checkbox = $(`<input type="checkbox" class="layer-checkbox" id="cb;${workspace};${layer_name}" />`);
                        checkbox.change(toggleMapLayer);
                        let cb_label = $(`<label for="cb;${workspace};${layer_name}">${layer_name}</label>`);
                        checkbox_container.append(checkbox, cb_label, $("<br>"));
                    });
                    ws_checkboxes.push(checkbox_container);
                }
                $("#ws_checkboxes").append(ws_checkboxes);
                $("#ws_select").append(selects).change(selectWorkspace);
            }).then(_ => initMap());
}